const Post = {
  initRelatedPostsSwiper() {
    const swiperEl = document.querySelector(".related-posts-swiper");
    if (!swiperEl) return;

    new Swiper(".related-posts-swiper", {
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        nextEl: ".ps-swiper-btn-next",
        prevEl: ".ps-swiper-btn-prev",
      },
      breakpoints: {
        576: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
    });
  },
};

$(function () {
  Post.initRelatedPostsSwiper();
});
